import React from 'react';
import { useDispatch } from 'react-redux';
import Link from 'next/link';

import Alert from '@r1-frontend/ui-react/components/Alert';
import Button from '@r1-frontend/ui-react/components/buttons/button';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { InfoCircle, TickCircle } from '@r1-frontend/ui-react/components/svg/main';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { BlockContainer, FullWidthListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { useMatchMediaByWidth } from '@r1-frontend/shared/hooks/useMatchMedia';

import CallbackContacts from '~/src/features/tariffBuilder/components/CallbackContacts';
import SummaryInfo from '~/src/features/tariffBuilder/components/SummaryInfo';
import AgreementInfoContainer from '~/src/features/tariffBuilder/containers/AgreementInfoContainer';
import { useCtxSelector } from '~/src/features/tariffBuilder/hooks';
import getSummaryInfo from '~/src/features/tariffBuilder/selectors/getSummaryInfo';
import { hasSelectedEquipment } from '~/src/features/tariffBuilder/selectors/hasSelectedEquipment';
import { openChat } from '~/src/store/actions/chat';

import { ChangePlanWebcabAlerts } from './ChangePlanWebcabAlerts';

const CurrentTariffFinal = (): JSX.Element => {
    const isLaptop = useMatchMediaByWidth(wideBreakpoints.laptop);
    const dispatch = useDispatch();

    const { summaryInfo, requestId, selectedTimeSlot, hasEquipment, isReplanError } = useCtxSelector(state => ({
        summaryInfo: getSummaryInfo(state),
        requestId: state.requestId,
        selectedTimeSlot: state.selectedTimeSlot,
        hasEquipment: hasSelectedEquipment(state),
        isReplanError: state.replanIsError,
    }));

    const openChatHandler = () => {
        dispatch(openChat());
    };

    return (
        <FullWidthListContainer $size={16} $direction={'column'}>
            {!requestId && hasEquipment &&
                <Alert Icon={InfoCircle} type={'error'}>
                    <Paragraph4>Не удалось создать заявку.</Paragraph4>
                </Alert>
            }
            <ChangePlanWebcabAlerts openChatHandler={openChatHandler}/>
            {isReplanError &&
                 <Alert Icon={InfoCircle} type={'error'}>
                    <Paragraph4>
                        При подтверждении даты визита инженера произошла ошибка. Наш специалист перезвонит вам для решения вопроса.
                    </Paragraph4>
                </Alert>
            }
            {selectedTimeSlot &&
                <Alert Icon={TickCircle} type={'success'}>
                    <Paragraph4>
                        Назначен визит инженера.
                        Следите за&nbsp;статусом или изменяйте заявку в&nbsp;личном кабинете.
                    </Paragraph4>
                </Alert>
            }
            {isLaptop &&
                <>
                    <AgreementInfoContainer/>
                    <BlockContainer
                        rounder={{
                            $radius: 24,
                        }}
                        indent={{
                            $united: [24],
                        }}
                    >
                        <FullWidthListContainer $direction={'column'} $size={24} $wrap='nowrap'>
                            <SummaryInfo
                                {...summaryInfo}
                            />
                        </FullWidthListContainer>
                    </BlockContainer>
                </>
            }
            <Link href={'/lk/vases'} passHref>
                <Button
                    bType={'secondary'}
                >
                    Перейти в личный кабинет
                </Button>
            </Link>
            <CallbackContacts/>
        </FullWidthListContainer>
    );
};

export default CurrentTariffFinal;
